/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { XDivider, YDivider, CreateTemplateIntentContainer } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
// import RequestTemplateFormat from '../Template/RequestListTemplate.jsx'
import { TextField, CancelButton, SaveButton, Autocomplete, Select } from '../../../irmlib/src/components/FormControls'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog, useSnackbar } from 'irmlib/containers'
import { OutlinedButton } from 'irmlib/components/Controls'
import { useHistory } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import * as constants from '../../../irmlib/src/common/constants'
import { getUser } from '../../../redux/global'
import { Box, Typography } from '@material-ui/core'
import { errorToast } from '../../../common/functions'
import {
  isAddActivityGetTemplateReady,
  CLEARED_TEMPLATE_RESULTS_STATE,
} from '../../../common/addActivityGetTemplateValidation'
import { useTranslation } from 'react-i18next'
import { GroupedMenu } from './GroupedMenu.jsx'
import { Card, CardContent } from '@mui/material'
import { AddActivityModal } from './AddActivityModal.jsx'
import TemplateMaterialTable from '../Template/RequestListTemplate_2.jsx'
import * as appConstants from '../../../services/common/appConstants.js'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }

const VerticalDivider = () =>
  <YDivider height='20px' />

const Buttons = props =>
  <>
    <CancelButton id={'createTemplate_button_cancel'} arrRefs={props.arrRefs} onClick={props.handleCancel} />
    <XDivider width='10px' />
    {props?.showTable && <SaveButton id={'createTemplate_button_save'} disabled={Object.keys(props.validationErrors).length > 0} arrRefs={props.arrRefs} postService={props.handlePageSave} saveLabel='buttons.addRequest' /> }
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array,
  showTable: PropTypes.bool,
  handlePageSave: PropTypes.func,
  handleCancel: PropTypes.func,
  validationErrors: PropTypes.object
}

const CancelButtons = props => 
  <>
    <CancelButton id={'createActivity_cancel'} onClick={props.handleCancel} arrRefs={props.arrRefs} />
  </>

CancelButtons.propTypes = {
  handleCancel: PropTypes.func
}

const ButtonsForSaveJobsForLater = props =>
  <>
    <CancelButton id={'createActivity_DialogBox_cancel'} arrRefs={props.arrRefs} onClick={closeGeneralDialog} />
    <SaveButton id={'createActivity_DialogBox_saveJob'} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.saveJob' />
  </>

ButtonsForSaveJobsForLater.propTypes = {
  arrRefs: PropTypes.array,
  postService: PropTypes.func
}

// const BottomPaddedButton = props =>
//   <>
//     <ThemeButton {...props} />
//     <VerticalDivider />
//   </>

const SELECT_ACOUNT_LEVEL1 = 0
const SELECT_ACOUNT_LEVEL2 = 1
const SELECT_ACOUNT_LEVEL3 = 3
// const SELECT_DISTRICT = 4
// const SELECT_BUILDING = 5
// const SELECT_ORDER_NUMBER = 6
// const SELECT_REMARKS = 7
// const SELECT_ASSET_TYPE = 8
const SELECT_TEMPLATE_TYPE = 9
const SELECT_LINE_OF_BUSINESS = 10
// const SELECT_CUSTOM_REQUEST_NAME = 11
const SELECT_WMS_INSTANCE = 11
const SELECT_WMS_REGION = 12



const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const initialSate = {
  showTable: false,
  lineOfBusiness: [],
  workerDetails: [defaultSelectOption],
  workerDetailsGde: null,
  wmsList: [defaultSelectOption],
  assetType: [],
  templateType: [],
  skpInstance: [defaultSelectOption],
  selectedWms: '',
  selectedWmsRegion: '',
  selectedTemplate: '',
  districts: [defaultSelectOption],
  selectedTemplateValues: [],
  WMSDistrictBuildings: [],
  WMSSystem: null,
  accountLevel1Description: '',
  validationErrors: {},
  openCustomFieldsDialog: false,
  saveStandardTempValues: [],
  addedCustomFields: [],
  renderNewTemplate: false,
  isCustomFieldsNotAdded: true,
  selectedCustomTemplateFields: [],
  selectedCustomTemplateFieldNames: [],
  enableAddFieldsBtn: true,
  isTemplateChanged: false,
  wmsRegion: '',
  wmsRegions: [],
  countryCode: '',
  districtId: '',
  country: '',
  errorMsg: '',
  showForm: false,
  wmsForCountry: '',
  buildings: [],
  templateData: [],
  templateName: '',
  haveExistingRequest: false,
  // selectedImage: false,
  selectedImageGsPath: false,
  showModal: false,
  postObject: {},
  template: {},
  wmsInstances: [],
  rowPassed: 0,
  selectedRowRequestId: 0,
  fromMultiReqs: false,
  customerEngmnt: [],
  cstmerEngmntList: [],
  custEngType: null,
  imProjName: null,
  newWorkflow: []
}


const AddActivity = () => {
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [state, setState, getState] = useMergeState(initialSate)
  const tableRef = useRef()
  const history = useHistory()
  const snackBar = useSnackbar()
  const { workerId: customerId } = getUser()
  // const { workerId: customerId, email: customerEmail = '' } = getUser()
  // const [selectedImage, setSelectedImage] = React.useState(null)
  const [selectedAssetType, setSelectedAssetType] = React.useState(null)
  const [pageData, setPageData] = React.useState([])
  const [getTemplateDisabled, setGetTemplateDisabled] = React.useState(true)

  useEffect(async() => {
    getActivityDetails(customerId)
  }, [])

  const formTemplate = [
    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      defaultValue: '',
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
      defaultValue: '',
      isDisable: true
    },
    {
      fieldKey: 'obj.obj1.check',
      defaultValue: false
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
      defaultValue: '',
      isDisable: true
    },
    {
      label: 'templates.district',
      fieldKey: 'districtId',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.building',
      fieldKey: 'buildingId',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.orderNumberRequired',
      fieldKey: 'orderNumber',
      isRequired: true
    },
    {
      label: 'templates.remarks',
      fieldKey: 'remarks',
      isRequired: false
    },
    {
      label: 'templates.assetType',
      fieldKey: 'assetId',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.templateType',
      fieldKey: 'templateType',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.lineOfBusiness',
      fieldKey: 'businessType',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'Search.wms',
      fieldKey: 'wmsInstance',
      // defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: ('Search.wmsRegion'),
      fieldKey: 'wmsRegion',
      // defaultValue: constants.defaultSelect,
      isRequired: true
    }
  ]
 
  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const getDistricts = async () => {
    const collection = await gdeTransactions.getLocationsForCountry(getState().country)
    const districtsList = [defaultSelectOption]
    collection.forEach((doc) => {
      districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
    })
    setState({ districts: districtsList })
  }

  const getSkpInstance = async (countryCode) => {
    const doc = await gdeTransactions.getSkpInstance(countryCode)
    const wmsList = []
    if (doc && 'skp' in doc) {
      const skpInstance = doc.skp.instances[0]
      setState({ wmsRegion: skpInstance })
      if (skpInstance !== undefined) {
        wmsList.push({
          value: 'SKP', label: 'SKP'
        })
      }
    }
    if (doc && 'oneil' in doc) {
      const oneilInstance = doc.oneil.instances
      const instances = oneilInstance.map((key) => ({ value: key, label: key }))
      setState({ wmsRegions: instances })
      if (instances?.length > 0) {
        wmsList.push({
          value: 'ONEIL', label: 'ONEIL'
        })
      }
    }

    setState({
      wmsInstances: wmsList
    })
  }

  const getBuildings = async (district) => {
    let buildings = []
    if (district && district !== constants.defaultSelect) {
      const buildingsSnapshot = await gdeTransactions.getBuildingForDistrict(district)
      buildings = Object.entries(buildingsSnapshot)?.map(([key, value]) => ({ value: key, label: value }))
      setState({ buildings: buildings }) 
    }
    return buildings
  }

  const getActivityDetails = async (userId) => {
    setBusy()
    const workerDetails = await gdeTransactions.getWorkerDetails(userId)
    const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(userId)
    const [lineOfBusiness, assetType, , templateType, customTemplateName, , , , custEngmntType, , newInsideOutsideWorkflowList] = await gdeTransactions.getGdeConfig()
    const countryCode = workerDetailsGde?.gdeCountryCode || workerDetails.countryCode
    const country = workerDetailsGde?.gdeCountry || workerDetails.country
    for (const key in assetType) {
      if (assetType[key].name === 'Transmittal Sheet') {
        delete assetType[key]
      }
    }
    await getSkpInstance(countryCode)
    await getBuildings(workerDetailsGde?.district[0])
    const lineOfBusinessData = Object.entries(lineOfBusiness).map(([key, value]) => ({ value: value.name, label: value.name }))
    const templateTypeData = Object.entries(templateType).map(([key, value]) => ({ value: value.name, label: value.name }))
    // const wmsInstances = Object.entries(wmsConfig).map(([key, value]) => ({ value: value.name, label: value.name }))
    const custEngmntTypeData = Object.entries(custEngmntType).map(([key, value]) => ({ value: value.name, label: value.name }))
    // const insideOutsideWorkflowListData = Object.entries(insideOutsideWorkflowList).map(([key, value]) => ({ value: value.name, label: value.name }))
    setState(
      { 
        workerDetails: workerDetails, 
        countryCode: countryCode, 
        districtId: workerDetails?.gdeDistrict, 
        country: country,
        lineOfBusiness: lineOfBusinessData,
        customTemplateName: customTemplateName,
        assetType: assetType,
        templateType: templateTypeData,
        // wmsInstances: wmsInstances
        customerEngmnt: [{ value: constants.defaultSelectForCE, label: constants.defaultSelectForCE }, ...custEngmntTypeData],
        newWorkflow: newInsideOutsideWorkflowList
      })
    arrRefs[SELECT_WMS_INSTANCE].current.focus()
    arrRefs[SELECT_LINE_OF_BUSINESS]?.current?.setValue('NA')
    await getDistricts()
    validationCheck()
    clearBusy()
  }

  const getRequestFields = async (templateRows) => {
    const fields = [...templateRows].sort((a, b) => {
      const aDate = new Date(a.createdTS)
      const bDate = new Date(b.createdTS)
      return bDate - aDate
    })
    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })
      return gdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.requestId,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          requestFields: templateFields,
          imgReference: doc.imgReference
        }
      })
    })
    return Promise.all(resultPromises)
  }

  const checkForExistingRequests = async() => {
    const formValues = formTemplate.reduce((values, field, index) => {
      const ref = arrRefs[index]
      if (ref && ref.current) {
        values[field.fieldKey] = ref.current.getValue()
      }
      return values
    }, {})
    const isFedCust = await gdeTransactions.getFederalCustomers(
      formValues.accountLevel1,
      formValues.accountLevel2 || '',
      formValues.accountLevel3 || ''
    )
    if (isFedCust) {
      setState({ errorMsg: t('smartCatalog.smartErr') })
      setPageData([])
    } else {
      setState({ errorMsg: '' })
      const UpdatedformValues = { ...formValues, assetType: selectedAssetType }
      const requestList = []
      const requests = await gdeTransactions.getRequests(UpdatedformValues)
      requests.forEach((doc) => {
        requestList.push(doc.data())
      })
      const pageRows = await getRequestFields(requestList)
      setState({
        fromMultiReqs: formValues.wmsInstance === 'ONEIL',
        templateData: requestList,
        haveExistingRequest: true,
        showTable: true, // change
        showForm: true,
      })
      setPageData(pageRows)
    }
  }

  const clearTemplateResults = ({ clearTemplateTypeField = false } = {}) => {
    if (clearTemplateTypeField) {
      arrRefs[SELECT_TEMPLATE_TYPE]?.current?.clear()
    }
    setPageData([])
    setState({ ...CLEARED_TEMPLATE_RESULTS_STATE })
  }

  const onChangeAssetType = (value) => {
    if (value) {
      setSelectedAssetType(value)
      clearTemplateResults({ clearTemplateTypeField: true })
      setState({ showForm: false })
      validationCheck(value)
    } else {
      setSelectedAssetType(null)
      clearTemplateResults({ clearTemplateTypeField: true })
      validationCheck(null)
    }
  }

  const handleTemplateTypeChange = () => {
    clearTemplateResults()
    validationCheck()
  }

  const handleLineOfBusinessChange = () => {
    clearTemplateResults()
    validationCheck()
  }

  const handleAddActivity = async (postObject, rows) => {
    let found = null
    let fields = {}
    let requestFound = false
    if (getState().selectedRowRequestId !== 0) {
      requestFound = true
      found = getState().templateData.find(obj => obj.requestId === getState().selectedRowRequestId)
    }
    if (found) {
      fields = found.template
    }
    if (requestFound && found) {
      setState({
        showModal: true,
        postObject: postObject,
        template: fields,
        customTemplateName: found.customTemplateName 
      })
    }
  }

  const handleSelectedRows = async (selectedRow) => {
    setState({
      selectedRowRequestId: selectedRow,
      rowPassed: selectedRow
    })
  }

  const handleShowModal = () => {
    setState({
      showModal: false
    })
  }

  const handleSaveActivity = async (modalData) => {
    setBusy()
    try {
      const { lockedTemplateFields } = modalData
      let fields = {}
      let parentRequestId = null
      let requestFound = false
      let requestData = null
      if (getState().selectedRowRequestId !== 0) {
        requestFound = true
        const found = getState().templateData.find(obj => obj.requestId === getState().selectedRowRequestId)
        parentRequestId = getState().selectedRowRequestId
        fields = found.template
        requestData = found
        setState({
          templateName: found.templateName,
        })
      }

      const idpFields = {}
      const lockedFields = {}
      Object.keys(fields).map((key) => {
        delete fields[key].fieldName
        if (lockedTemplateFields[key]) {
          fields[key].isLocked = true
          fields[key].lockedValue = lockedTemplateFields[key]
          lockedFields[key] = lockedTemplateFields[key]
        } else {
          fields[key].isLocked = false
          fields[key].lockedValue = ''
          idpFields[key] = fields[key]
        }
        return true
      })
      // Object.keys(idpFields).map((key) => {
      //   idpFields[key].confidence = Number(modalData.QCBypass) || 0
      //   return true
      // })
      if (requestFound) {
        const timeNow = Date.now()
        const documentId = timeNow.toString()
        const data = {
          accountLevel1: modalData.accountLevel1.toUpperCase() || requestData.accountLevel1,
          accountLevel2: modalData.accountLevel2.toUpperCase() || requestData.accountLevel2,
          accountLevel3: modalData.accountLevel3.toUpperCase() || requestData.accountLevel3,
          assetType: selectedAssetType || requestData.assetType,
          templateType: modalData.templateType === constants.defaultSelect ? requestData.templateType : modalData.templateType,
          district: modalData.districtId,
          boxId: null,
          countryCode: getState()?.countryCode,
          templateName: getState()?.templateName,
          createdTS: (new Date()).toISOString(),
          requestId: documentId,
          customTemplateName: modalData.customTemplateName || '',
          imgReference: modalData.selectedImage || requestData.imgReference,
          imgReferenceURI: modalData.selectedImageGsPath || requestData.imgReferenceURI,
          lob: modalData.businessType,
          customRequestName: modalData.customRequestName,
          orderId: modalData.orderNumber || '',
          building: modalData.buildingId,
          remarks: modalData.remarks || '',
          srcSystem: 'gde',
          status: 'pending',
          totalBoxes: null,
          totalFiles: null,
          updateTS: (new Date()).toISOString(),
          workerId: getState()?.workerDetails?.workerId,
          template: idpFields,
          templateLocked: lockedFields,
          isTemplate: false,
          refRequestId: parentRequestId,
          isProcessed: false,
          isPublished: false,
          isReopen: false,
          wmsCode: arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue(),
          wmsRegion: arrRefs[SELECT_WMS_INSTANCE]?.current?.getValue() === 'SKP' ? getState()?.wmsRegion : getState()?.selectedWmsRegion,
          activityType: modalData?.custEngType,
          activityName: modalData?.imProjName,
          dataLocation: modalData?.workflow,
          imgLimit: Number(modalData?.imgLimit) || appConstants.totalImagesAllowedToCapture,
          // confidence: Number(modalData.QCBypass) || 0
        }

        await gdeTransactions.createActivity(documentId, data)
        closeGeneralDialog()
        setTimeout(snackBar(t('toast.requestCreated', { requestId: documentId })), 50000)
        history.push(routePaths.viewActivity)
      } else {
        errorToast({ message: t('toast.requestError'), title: t('toast.error') })
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('unable to create request :-', err?.message)
      errorToast({ message: t('login.someThingWentWrongError'), title: t('toast.error') })
    } finally {
      clearBusy()
    }
  }

  const handleCancel = () => {
    openGeneralDialog({
      title: t('templates.cancel'),
      message: t('options.cancelJobMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleCancelButtonOnClick} >buttons.yes</ContainedButton>
    </>

  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.push(routePaths.root)
  }

  const validationCheck = (assetTypeOverride) => {
    setGetTemplateDisabled(!isAddActivityGetTemplateReady({
      arrRefs,
      selectedAssetType,
      assetTypeOverride,
    }))
  }

  const selectWms = (value) => {
    setState({ selectedWms: value })
    clearTemplateResults({ clearTemplateTypeField: true })
    validationCheck()
  }

  const selectOneil = (value) => {
    if (value) {
      setState({ selectedWmsRegion: value })
    }
    clearTemplateResults()
    validationCheck()
  }

  const handleAccountFieldsChange = () => {
    clearTemplateResults({ clearTemplateTypeField: true })
    validationCheck()
  }
  state.templateType.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })
  state.lineOfBusiness.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })
  
  return (
    <>
      <MainRouteSubRoutePage
        subTitle='routeTitles.addSmartCatalogSubTitle'
        buttons={getState()?.showForm && <Buttons arrRefs={arrRefs} handleCancel={handleCancel} handlePageSave={handleAddActivity} showTable={getState()?.showTable} validationErrors={getState().validationErrors} />} createPage={true}
      >
        <Card style={{ width: '70vw', margin: '0.5rem' }}>
          <CardContent>
            <CreateTemplateIntentContainer>
              <Select
                id={'templateSearch_wms'}
                // onChange={getWms}
                data={data}
                items={state?.wmsInstances}
                fieldTemplate={formTemplate[SELECT_WMS_INSTANCE]}
                ref={arrRefs[SELECT_WMS_INSTANCE]}
                onChange={selectWms}
                noTranslateItems
                noTranslate={true}
              />
              {getState()?.selectedWms === 'ONEIL' &&
                <Select
                  id={'addActivity_wmsRegion'}
                  data={data}
                  items={state?.wmsRegions}
                  fieldTemplate={formTemplate[SELECT_WMS_REGION]}
                  ref={arrRefs[SELECT_WMS_REGION]}
                  onChange={selectOneil}
                  noTranslateItems
                  noTranslate={true}
                />
              }
              <TextField
                id={'createActivity_accountLevel'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
                onKeyUp={handleAccountFieldsChange}
              />
              <TextField
                id={'createActivity_accountLeve2'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
                onKeyUp={handleAccountFieldsChange}
              />
              <TextField
                id={'createActivity_department'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
                onKeyUp={handleAccountFieldsChange}
              />
              <GroupedMenu
                id={'createActivity_assetType'}
                data={data}
                assetTypes = {state.assetType}
                label= {t('templates.assetType')}
                onSelect={onChangeAssetType}
              />
              <Autocomplete
                id={'createActivity_templateType'}
                data={data}
                options={state?.templateType}
                fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
                ref={arrRefs[SELECT_TEMPLATE_TYPE]}
                onChange={handleTemplateTypeChange}
                noTranslateItems
              />
              <Autocomplete
                id={'createActivity_lineOfBusiness'}
                data={data}
                options={state.lineOfBusiness}
                fieldTemplate={formTemplate[SELECT_LINE_OF_BUSINESS]}
                ref={arrRefs[SELECT_LINE_OF_BUSINESS]}
                onChange={handleLineOfBusinessChange}
                noTranslateItems
              />

              <ContainedButton
                onClick={() => checkForExistingRequests()}
                disabled={getTemplateDisabled}
                style={{
                  width: '150px',
                  height: '32px'
                }}
              >buttons.getTemplate</ContainedButton>
            </CreateTemplateIntentContainer>
            <Typography paragraph={true} style={{ fontSize: '16px', color: '#FFF', backgroundColor: '#db4437', width: 'fit-content' }}>{getState()?.errorMsg}</Typography> 
          </CardContent>
        </Card>
        <Box component='div' style={{ backgroundColor: '#F3F3F3', width: '100%', height: '1rem', margin: 0, padding: 0 }} />
        {getState().showTable
          ? (
            <Box component='div' style={{ margin: '0.5rem' }}>
              <VerticalDivider />
              <TemplateMaterialTable
                ref={tableRef}
                data={pageData}
                selectedRecord={false}
                handleSelectedRows={handleSelectedRows}
                fromMultiReqs={getState().fromMultiReqs}
              />
            </Box>
            )
          : null}
        {getState().showModal
          ? (
            <AddActivityModal
              showModal={getState().showModal}
              handleShowModal={handleShowModal}
              handleSaveActivity={handleSaveActivity}
              defaultDistrict={state.districtId}
              districts={state.districts}
              buildingsList={state.buildings}
              postObject={getState().postObject}
              templateFields={getState().template}
              customerId={arrRefs[SELECT_ACOUNT_LEVEL1].current.value}
              customTemplateName={getState().customTemplateName}
              customerEngmnt={getState().customerEngmnt}
              defaultCountry={state.countryCode}
              newWorkflow={getState().newWorkflow}
            />
            )
          : null}
      </MainRouteSubRoutePage>
    </>
  )
}

export default AddActivity